import {
  Configuration,
  BrowserCacheLocation,
  LogLevel,
} from '@azure/msal-browser';
import { environment } from 'src/environments/environment';
import { LoggingService } from './utilities/logging/logging.service';

export const b2cPolicies = {
  names: {
    signUpSignIn: 'B2C_1_RemotecareLogin',
  },
  authorities: {
    signUpSignIn: {
      authority:environment.b2cConfig.authority
    },
  },
  authorityDomain: environment.b2cConfig.authorityDomain,
};

export const protectedResources = {
  etlApi: {
    endpoint: environment.apiurl,
    scopes:[environment.scopes],
  },
  realizerApi: {
    endpoint: environment.realizerUrl,
    scopes: [environment.scopes],
  }  
};

export const msalConfig: Configuration = {
  auth: {
    clientId:environment.b2cConfig.clientId,
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: '/',
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage,
  },
  system: {
    loggerOptions: {      
       loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
        let logginSvc = new LoggingService();
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        logginSvc.logException(new Error(message));
                        return;
                    case LogLevel.Info:
                      if(message.includes("loginFailure")){
                        logginSvc.logException(new Error("Login Failure " + message));
                      }
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            },
      piiLoggingEnabled: false,
    },
  },
};

export const loginRequest = {
  scopes: [],
};
